import { render } from "./table-pager.vue?vue&type=template&id=27e7ddb8&scoped=true&ts=true"
import script from "./table-pager.vue?vue&type=script&setup=true&lang=ts"
export * from "./table-pager.vue?vue&type=script&setup=true&lang=ts"

import "./table-pager.vue?vue&type=style&index=0&id=27e7ddb8&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e7ddb8"],['__file',"src/components/table-pager.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27e7ddb8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27e7ddb8', __exports__)) {
    console.log('reload')
    api.reload('27e7ddb8', __exports__)
  }
  
  module.hot.accept("./table-pager.vue?vue&type=template&id=27e7ddb8&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('27e7ddb8', render)
  })

}


export default __exports__